<template>
    <div class="service">
        <mt-header fixed title="服务记录">
            <router-link to="/" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <div class="service-header">
                <div class="service-header-info">
                    <div class="service-header-img">
                        <img :src="'../../static/'+service_img+'.png'" />
                    </div>
                    <div class="service-header-text">
                        {{ service }}
                    </div>
                </div>
            </div>
            <div class="service-body">
                <div class="service-body-title">
                    <h3>请选择老人</h3>
                </div>
                <div class="search-content">
                    <input class="search" placeholder="输入姓名进行搜索" v-model="search" />
                    <i class="mintui mintui-search"></i>
                </div>

                <ul class="mui-table-view community-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                    <!--li数据遍历循环部分-->
                    <li class="mui-table-view-cell community-card" v-for="item in list">
                        <div class="card-left">
                            <div class="card-name">{{ item.name }}</div>
                            <div class="card-address">{{ item.id_number }}</div>
                            <div class="card-address">{{ item.live_city_name+item.live_country_name+item.live_town_name+item.live_village_name+item.live_address }}</div>
                        </div>
                        <div class="card-right">
                            <a @click="choose(item.id,item.name)">选择</a>
                        </div>
                    </li>
                    <!--底部判断是加载图标还是提示“全部加载”-->
                    <li class="more_loading" v-show="queryLoading">
                        <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                    </li>
                    <li class="more_loading" v-show="!queryLoading">
                        <span class="loaded">已全部加载</span>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>
<style scoped>
    .service-header{
        padding:20px;
    }
    .service-header-info{
        display:flex;
        background:#fff;
        align-items: center;
        padding:10px 0;
        justify-content: center;
        border-radius:10px;
    }

    .service-header-img{
        width:15%;
    }

    .service-header-img img{
        width:100%;
    }

    .service-body{
        padding:0 20px;
    }

    .search-content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #fff;
        margin: 0 auto;
        height: 40px;
        line-height: 40px;
    }

    .search-content .search{
        font-size: medium;
        width: 100%;
        border: none;
        padding:20px;
    }

    .search-content .search:focus{
        outline: none;
    }

    .search-content i{
        padding-right:10px;
        font-size:18px;
    }

    .service-body-title{
        margin-bottom:10px;
    }


    .community-list{
        padding:0 0 50px 0;
    }

    .community-list li{
        list-style:none;
    }

    .community-card{
        display:flex;
        justify-content: space-between;
       /* border:1px solid #dedede;*/
        background:#fff;
        /*  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2), 0 2px 3px 0 rgba(0, 0, 0, 0.15);*/
        margin-bottom:10px;
    }

    .card-left{
        width:80%;
        font-size:14px;
        padding:10px 8px;
    }

    .card-right{
        width:20%;
        justify-content:center;
        display:flex;
        align-items: center;
        background:#ffcb01;
        color:#fff;
    }
    .card-name{
        padding:5px 0;
    }
    .card-address{
        font-size:12px;
    }

    .service-body-title h3{
        padding-top:0;
        margin-top:0;
    }

</style>
<script>
    export default{
        data(){
            return {
                service_img:'care',
                service:this.$route.params.type,
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,

                //初始化无限加载相关参数
                list:[],
                search:'',
                queryLoading: true,
                pageNum:1,
            }
        },

        created(){

            let type_img =  Object();
            type_img['入户'] = 'care';
            type_img['电访'] = 'phone';
            type_img['医疗'] = 'tingzhenqi';
            type_img['家政'] = 'other';
            type_img['便民活动'] = 'bianmin';
            type_img['基础教育'] = 'jiaoyu';
            type_img['康乐活动'] = 'kangle';
            type_img['志愿活动'] = 'zhiyuan';
            type_img['个案工作'] = 'gean';
            type_img['小组工作'] = 'xiaozu';

            this.service_img = type_img[this.$route.params.type];

            this.$indicator.open('加载中');

            this.$axios.post("/elder/list", {openid:this.openid,page:1})
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.list = data.data.data.data;
                        if(this.list.length<10){
                            this.queryLoading = false;
                        }
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },


        watch:{
            search:{
                handler(){


                    this.pageNum = 1;
                    this.$axios.post("/elder/list", {openid:this.openid,page:1,search:this.search})
                        .then(data => {
                            if (data.data.code === 'OK') {
                                this.list = data.data.data.data;
                                if(this.list.length<10){
                                    this.queryLoading = false;
                                }
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                    if(this.search===''){
                        this.queryLoading = true;
                    }
                }
            }
        },


        methods:{
            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                this.pageNum++;
                this.$axios.post("/elder/list", {openid:this.openid,page:this.pageNum,search:this.search}).then(data => {
                    if(data.data.code === 'OK'){

                        this.list = this.list.concat(data.data.data.data);
                        if(data.data.data.data.length===0){
                            this.queryLoading = false;
                        }
                    }

                });
            },

            choose(id,name){
                this.$router.push({path:'/service2',query:{type:this.service,elder:id,elderName:name}});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/service.vue